import { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
//import LPBrandsImage1 from '../../assets/lpBrands/lpBrandsImage1.png';
import LPBrandsImage2 from '../../assets/lpBrands/lpBrandsImage2.png';
//import LPBrandsImage3 from '../../assets/lpBrands/lpBrandsImage3.png';
import LPBrandsImage4 from '../../assets/lpBrands/lpBrandsImage4.png';
import LPBrandsImage5 from '../../assets/lpBrands/lpBrandsImage5.png';
import FairExText from '../../assets/textImage/fairex-text.svg';
import FairGenText from '../../assets/textImage/fairgen-text.svg';
import StartCreatingButton from '../../components/StartCreatingButton ';

export const LPSectionBrands = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const lpSectionBrandsData = {
    sections: [
      {
        title: (
          <>
            Use{' '}
            <Box
              component="img"
              src={FairExText}
              alt="FairEx"
              sx={{
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '1.2em',
                mb: '4px'
              }}
            />{' '}
            to search and collaborate with talents for your campaign
          </>
        ),
        description:
          'Search for your favorite celebrities, influencers and athletes and collaborate with them to create new content.',
        images: [LPBrandsImage2]
      },
      {
        title: (
          <>
            Unleash your creativity with{' '}
            <Box
              component="img"
              src={FairGenText}
              alt="FairGen"
              sx={{
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '1.2em',
                mb: '4px'
              }}
            />
            ’s cutting edge image generation technology
          </>
        ),
        description:
          'State of the art models available across different price and quality specifications. Promote products using influencer’s likeness — no physical shoot needed.',
        images: [LPBrandsImage4]
      },
      {
        title: 'Edit and enhance your images effortlessly with our intuitive Canvas',
        description: (
          <>
            Enhance your images by upscaling, retouching, deblurring and more. Change background, erase objects, inpaint, outpaint and many more{' '}
            <strong>text</strong> and <strong>mask</strong> based editing capabilities at your fingertips.
          </>
        ),
        images: [LPBrandsImage5, LPBrandsImage5]
      }
    ],
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % lpSectionBrandsData.sections[0].images.length);
    }, 4000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      id="brands"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        mt: 2,
        pt: 10,
        pb: 10,
        px: { xs: 2, md: 4, lg: 4 }
      }}
    >
      <Typography
        component="h1"
        variant="h3"
        fontFamily="Inter"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '29px', sm: '29px', md: '41.8px' },
          lineHeight: '100%',
          letterSpacing: '0px',
          textAlign: 'center',
          mb: 2,
          [theme.breakpoints.down('md')]: {
            mb: 3
          }
        }}
      >
        Brands
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 2, md: 5 },
          [theme.breakpoints.down('md')]: {
            gap: '10px'
          }
        }}
      >
        {lpSectionBrandsData.sections.map((section, index) => {
          const isEven = index % 2 === 0;
          const currentImage = section.images[currentImageIndex];

          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                width: { xl: 1260 },
                height: { xl: 484 },
                gap: '35px',
                alignItems: 'center',
                mt: 6,
                mb: 4,
                flexDirection: isEven ? 'row' : 'row-reverse',
                flexWrap: 'wrap',
                [theme.breakpoints.down('md')]: {
                  flexDirection: 'column',
                  width: '100%',
                  height: 'auto',
                  gap: '10px',
                  mt: 1,
                  mb: 1
                }
              }}
            >
              <Box sx={{ flex: 2, width: '100%' }}>
                <Box
                  component="img"
                  src={currentImage}
                  alt={`Section ${index + 1} Image`}
                  sx={{
                    // backgroundColor: 'red',
                    width: '100%',
                    height: { xs: 'auto', md: 'auto', lg: 'auto' },
                    objectFit: 'cover',
                    
                    borderRadius: '12px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                    transition: 'background-image 1s ease-in-out',
                    border: ' 1px solid #7A7A7A',
                  }}
                />
              </Box>
              <Box
                sx={{
                  
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'left',
                  maxWidth: { xs: '100%', lg: 325 },
                  mt: { xs: 0, lg: 0 },
                  px: { xs: 1, sm: 2, md: 3, lg: 0 }
                }}
              >
                <Typography
                  component="h2"
                  variant="h4"
                  fontFamily="Inter"
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: '16px', md: '16px', lg: '29px' },
                    lineHeight: '110%',
                    color: '#C0C0C0',
                    [theme.breakpoints.down('md')]: {
                      textAlign: 'center',
                      lineHeight: '120%',
                      color: '#FFFFFF'
                    }
                  }}
                >
                  {section.title}
                </Typography>
                <Typography
                  variant="h5"
                  fontFamily="Inter"
                  sx={{
                    fontWeight: 300,
                    fontSize: { xs: '15px', md: '16px' },
                    color: '#c0c0c0',
                    mt: 2,
                    maxWidth: { xs: '100%', lg: 315 },
                    [theme.breakpoints.down('md')]: {
                      textAlign: 'center'
                    }
                  }}
                >
                  {section.description}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      <Box
        sx={{
          mt: 0,
          [theme.breakpoints.down('md')]: {
            mt: 0
          }
        }}
      >
        <StartCreatingButton
          maxWidth={isMdOrBelow ? '131px' : '200px'}
          maxHeight={isMdOrBelow ? '49px' : '52px'}
          fontSize={isMdOrBelow ? '14px' : '16px'}
          padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
        />
      </Box>
    </Box>
  );
};
